import * as React from 'react';

const SvgCarryAndPackIcon = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    id="carry-and-pack-icon-32x32_svg__Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    width={32}
    height={32}
    xmlSpace="preserve"
    {...props}
  >
    <style>{'.carry-and-pack-icon-32x32_svg__st0{fill:#e72623}'}</style>
    <path
      className="carry-and-pack-icon-32x32_svg__st0"
      d="M25.05 29.025H6.85c-1.1 0-1.9-.9-1.9-1.9v-1.9c0-1.1.9-1.9 1.9-1.9h18.2c1.1 0 1.9.9 1.9 1.9v1.9c0 1-.8 1.9-1.9 1.9z"
    />
    <path d="M7.55 9.825h-1.3v13.5h1.3v-13.5zM25.65 9.825h-1.3v13.5h1.3v-13.5zM10.15 23.125h-1.3v5.8h1.3v-5.8zM23.15 23.125h-1.3v5.8h1.3v-5.8z" />
    <path d="M27.25 27.025h-.3v-1.3h.2c.6 0 1.1-.5 1.1-1.1v-6.6h-3.2v-1.3h3.8c.4 0 .8.3.8.8v7.2c-.1 1.3-1.1 2.3-2.4 2.3z" />
    <path d="M29.05 17.325h-1.3c0-.8-.5-1.5-1.2-1.8l-1.7-.7.5-1.2 1.7.7c1.2.5 2 1.7 2 3zM4.95 27.025h-.2c-1.3 0-2.4-1.1-2.4-2.4v-7.2c0-.4.3-.8.8-.8h3.8v1.3h-3.2v6.7c0 .6.5 1.1 1.1 1.1h.2v1.3h-.1z" />
    <path d="M4.25 17.325h-1.3c0-1.3.8-2.5 2-3l1.7-.7.5 1.2-1.7.7c-.8.3-1.2 1-1.2 1.8zM23.75 10.825h-4.5v-1.3h4.5c1.1 0 1.9-.9 1.9-1.9v-4.6H6.15v4.5c0 1.1.9 1.9 1.9 1.9h4.5v1.3h-4.5c-1.8 0-3.2-1.5-3.2-3.2v-5.8h22.1v5.8c0 1.9-1.4 3.3-3.2 3.3z" />
    <path d="M16.25 14.025h-.5l-.2-.2-1.5-1.5v-5.1h3.9v5.1l-1.7 1.7zm-.9-2.2.6.6.6-.6v-3.2h-1.3v3.2h.1z" />
    <path d="M19.25 7.225h-6.5v1.3h6.5v-1.3z" />
    <path
      className="carry-and-pack-icon-32x32_svg__st0"
      d="M20.45 21.525h-9c-1.1 0-2-.9-2-2v-3.9h13v3.9c0 1.1-.9 2-2 2z"
    />
    <path d="m15.95 19.525-6.6-1.3.3-1.3 6.3 1.3 6.4-1.3.2 1.3-6.6 1.3z" />
  </svg>
);

export default SvgCarryAndPackIcon;
